export default ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13">
      <path
        fill="#000F45"
        fill-rule="evenodd"
        d="M304,721.5 L298.166667,727.0125 L298.166667,723.7125 C296.246518,723.7125 294.648443,724.037496 293.372395,724.6875 C292.096348,725.337504 290.972227,726.374993 290,727.8 C290.996533,722.574974 293.718727,719.637504 298.166667,718.9875 L298.166667,715.8 L304,721.5 Z"
        transform="translate(-290 -715)"
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/assets/images/share-icon.js